import { useTranslation } from 'react-i18next';
import HomeNotice from '@/components/app/home/HomeNotice';
import { ROUTES } from '@/routes/paths';

interface AddEmployeesCardProps {
  /** Закрыть напоминание (крестик). Если не передан — крестик не показываем. */
  readonly onClose?: () => void;
}

/**
 * Напоминание «Главной»: пригласить сотрудников. Показывается владельцу-менеджеру аттестованной организации,
 * у которой ещё нет ни одного сотрудника (см. AppHome). Кнопка ведёт на вкладку «Сотрудники» «Моей компании»,
 * где открывается диалог приглашения. Крестик скрывает напоминание, решение запоминается в AppHome.
 */
export default function AddEmployeesCard({ onClose }: AddEmployeesCardProps) {
  const { t } = useTranslation();
  return (
    <HomeNotice
      title={t('app.home.addEmployees.title')}
      hint={t('app.home.addEmployees.hint')}
      action={{ to: ROUTES.APP_COMPANY_EMPLOYEES, label: t('app.home.addEmployees.cta') }}
      onClose={onClose}
    />
  );
}
